<template>
  <div>
    <template v-if="!wapShow">


    <headers1 :menuIndex="2"></headers1>
    <div class="product-box">
      <div style="background: linear-gradient( to right, #19203B 0%, #19203B 40%, rgb(241, 243, 249)40%, rgb(241, 243, 249) 100% );">
        <div class="banner-box app-content flex">
          <div class="banner-left">
            <ul>
              <li :class="{'select':bannerIndex==1}" @click="bannerIndex=1"><img src="@/assets/imgs/product/11.png" />预应力工程全数量检测系统</li>
              <li :class="{'select':bannerIndex==2}" @click="bannerIndex=2"><img src="@/assets/imgs/product/9.png" />锚下预应力检测系统</li>
              <li :class="{'select':bannerIndex==3}" @click="bannerIndex=3"><img src="@/assets/imgs/product/10.png" />预应力锚索基础试验系统</li>
              <li :class="{'select':bannerIndex==4}" @click="bannerIndex=4"><img src="@/assets/imgs/product/8.png" />智能拉拔系统</li>
              <li :class="{'select':bannerIndex==5}" @click="bannerIndex=5"><img src="@/assets/imgs/product/12.png" />远程监测系统</li>
            </ul>
          </div>
          <div class="banner-right">
            <template v-if="bannerIndex==1">
              <img style="width: 500px;margin-top: 30px"  src="@/assets/imgs/product/1.png" />
            </template>
            <template v-if="bannerIndex==4">
              <img style="width: 590px;margin-top: 64px;margin-left: 34px"  src="@/assets/imgs/product/2.png" />
            </template>
            <template v-if="bannerIndex==2">
              <img style="width: 590px;margin-top: 64px;margin-left: 34px"  src="@/assets/imgs/product/3.png" />
            </template>
            <template v-if="bannerIndex==3">
              <img style="width: 590px;margin-top: 64px;margin-left: 34px"  src="@/assets/imgs/product/4.png" />
            </template>
            <template v-if="bannerIndex==5">
              <img style="    width: 400px;margin-top: 48px;margin-left: 124px;"  src="@/assets/imgs/product/5.png" />
            </template>
          </div>
        </div>
      </div>

      <div class="product1">
        <div class="app-content flex-sp">
          <div class="product1-left">
            <ul>
              <li class="select">
                 <img src="@/assets/imgs/common/3.png" />
                 <span>01</span><span style="margin: 0 16px">|</span><span>产品定位</span>
              </li>
              <li class="select">
                <img src="@/assets/imgs/common/3.png" />
                <span>02</span><span style="margin: 0 16px">|</span><span>目标客户</span>
              </li>
              <li class="select">
                <img src="@/assets/imgs/common/3.png" />
                <span>03</span><span style="margin: 0 16px">|</span><span>产品简介</span>
              </li>
            </ul>
          </div>
          <div class="product1-right">
            <div class="bottom">
              <div class="p2">
                  <div class="p2-1" v-if="bannerIndex==1">
                    面向基建领域的预应力工程提供基于物联网智能感知、大数据分析决策、云平台智慧协同的数字化施工质量监测与管控解决方案。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==2">
                    一种用于工后检测的锚下有效预应力检测设备。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==3">
                    一款经典的预应力锚索基础类试验系统。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==4">
                    一款先进的预应力锚索拉拔设备。
                  </div>
                  <div  class="p2-1" v-if="bannerIndex==5">
                    一款通用化的岩土工程传感器远程采集传输设备。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==1">
                    业主、行业主管机构、总承包、大型监理单位、检测单位 。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==2">
                    检测单位、施工单位、研究机构、行业主管部门。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==3">
                    检测单位、研究机构、咨询机构、施工单位。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==4">
                    检测单位、研究机构、施工单位、监理单位。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==5">
                    研究机构、试验监测机构、施工单位、系统集成商。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==1">
                    基于施工机械作业信息等大数据，融合感知层、传输层、平台层和应用层等软硬件设施设备，构建而成的可视化平台型质量解决方案。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==2">
                    当前检测行业中技术原理最先进（第 4 代）、检测速度最快、性能可靠性最好、智能化程度最高的专用设备，通过 1 5 年的
                    持续研发迭代，有效解决了“检不了、检不准、检得慢”等问题。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==3">
                    基于经典力学原理，采用高精度传感器，结合先进数据采集和测控技术，实现预应力锚索基础试验自动化采集、分析和评价。十余年来，被广泛应用于预应力领域相关研究及试验检测。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==4">
                    当前最先进的预应锚索拉拔系统，以传感器测量和伺服闭环控制技术形成的智能油泵，根据锚固体系预应力施加要求，灵活搭配千斤顶和夹具，实现各类预应力筋拉拔过程中全自动操作。有效解决了传统拉拔类产品“手摇式”操作、人工测量、记录存在的粗放和低效问题。
                  </div>
                  <div class="p2-1" v-if="bannerIndex==5">
                    基于低功耗并行采样技术，自主研发设计的一款用于监测类传感器的无线自动采集传输设备。
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="product2">
        <div class="header-title">核心功能</div>
        <div class="header-gong app-content">
          <template v-if="bannerIndex==1">
            <img style="width: 100%" src="@/assets/imgs/product/7.png" />
          </template>
          <template v-else-if="bannerIndex==2">
            基于预应力锚固接触力学理论，针对锚固体系中锚固单元状态跟踪技术，通过对施加预应力后的预应力筋进行反向加载，并准确捕捉锚固临界点进行锚下有效预应力的测定。
          </template>
          <template v-else-if="bannerIndex==3">
            根据预应力工程学和材料力学原理，采用高精度传感器，结合数据采集和测量控制技术，以简洁灵活的功能配置，实现各类试验过程中的“荷载 - 位移”参数的连续动态测试和自动采集。
          </template>
          <template v-else-if="bannerIndex==4">
            基于锚索预应力作用机理与过程分析，根据锚固体系工作原理，综合运用传感器测量和伺服闭环控制技术，通过对工艺参数的标准化和操作过程自动化，实现预应力拉拔的智能化施工或试验作业。
          </template>
          <template v-else-if="bannerIndex==5">
            <div style="text-align: center;position: relative">
              <span class="product2-index6">自动采集</span>
              <img style="width: 900px;" src="@/assets/imgs/product/6.png" />
              <span class="product2-index6" style="left:1087px">无线传输</span>
            </div>

          </template>
        </div>

        <div class="app-content" style="margin: 40px auto">
          <div class="header-title">产品优势</div>
          <div class="product2-ul flex-sp">
            <template v-if="bannerIndex==1">
              <div class="product2-li">
                <img src="@/assets/imgs/product/icon/1-1.png" />
                <p>全数量</p>
                <span>从抽样检测转变为全样监控，可掌握每项工程或工序的具体情况，将质量控制由“抽样评价”变为“100% 掌握”。</span>
              </div>
              <div class="product2-li">
                <img src="@/assets/imgs/product/icon/1-2.png" />
                <p>全过程</p>
                <span>从事后检测转变为事中控制，在过程中实时分析并及时预警，将质量问题由“隐蔽”变为“透明”。</span>
              </div>
              <div class="product2-li">
                <img src="@/assets/imgs/product/icon/1-3.png" />
                <p>数字化</p>
                <span>基于施工作业大数据等信息，有机融合每一次施工中的人、机、料、法、环具体要素，实现质量进度的全面感知，数据的智能分析与共享，质量提升的协同管理。</span>
              </div>
              <div class="product2-li">
                <img src="@/assets/imgs/product/icon/1-4.png" />
                <p>无人化</p>
                <span>通过物联网远程自动采集数据，无需人工现场检测作业；通过大数据智能分析，无需人工处理数据；通过数据实时共享协同，实现检测数据与结果的自动发布。</span>
              </div>
            </template>
            <template v-if="bannerIndex==2">
              <div class="product2-li">
                <img src="@/assets/imgs/product/icon/2-1.png" />
                <p>专业</p>
                <span>采用微动侦测技术对锚固单元的微运动过程进行动态跟踪与快速识别，对既有锚固锁定状态不产生扰动影响，操作过程既安全又专业。</span>
              </div>
              <div class="product2-li">
                <img src="@/assets/imgs/product/icon/2-2.png" />
                <p>精确</p>
                <span>测量系统采用高精度传感器组件，控制系统采用伺服闭环反馈策略，测量精度经国家法定计量机构进行校准测试和检定确认。</span>
              </div>
              <div class="product2-li">
                <img src="@/assets/imgs/product/icon/2-3.png" />
                <p>高效</p>
                <span>检测操作中，根据预设参数，系统以最优策略匹配运行参数，并自动完成数据的采集、处理、分析工作，单孔检测耗时低于 1 分钟。</span>
              </div>
              <div class="product2-li">
                <img src="@/assets/imgs/product/icon/2-4.png" />
                <p>可靠</p>
                <span>对系统机、电、液、控等核心部件，采用了集成化设计和模块化封装，运行平稳，故障率低，运维便捷。依托智能算法进行数据分析处理，结果客观真实。</span>
              </div>
            </template>

            <template v-if="bannerIndex==3">
              <div class="product2-li" style="height: 300px;;">
                <img src="@/assets/imgs/product/icon/3-1.png" />
                <p>经典</p>
                <span>采用经典力学原理，技术方法直观可靠。</span>
              </div>
              <div class="product2-li"  style="height: 300px;;">
                <img src="@/assets/imgs/product/icon/3-2.png" />
                <p>独立</p>
                <span>测控系统独立工作，可有效避免干扰因素。</span>
              </div>
              <div class="product2-li"  style="height: 300px;;">
                <img src="@/assets/imgs/product/icon/3-3.png" />
                <p>便捷</p>
                <span>软硬件设计高度模块化，安装操作便捷直观。</span>
              </div>
              <div class="product2-li"  style="height: 300px;">
                <img src="@/assets/imgs/product/icon/3-4.png" />
                <p>灵活</p>
                <span>配置灵活度高，可适应于各种工况下预应力测试需求。</span>
              </div>
            </template>

            <template v-if="bannerIndex==4">
              <div class="product2-li" style="height: 364px;">
                <img src="@/assets/imgs/product/icon/4-1.png" />
                <p>全自动</p>
                <span>预设参数后，在锚索预应力施加过程中，自动运行并完成张拉加载、稳压持荷和卸载锚固功能，有效避免了人工因素干扰。</span>
              </div>
              <div class="product2-li"  style="height: 364px;">
                <img src="@/assets/imgs/product/icon/4-2.png" />
                <p>高精度</p>
                <span>张拉力值采用传感器实时测量，动作执行机构采用伺服闭环策略进行反馈控制，运行状态平稳且切换无冲击。实际控制精度（法定计量：1%FS）远高于人工读取油压表（约 10%）进行手动操控精度。</span>
              </div>
              <div class="product2-li"  style="height: 364px;">
                <img src="@/assets/imgs/product/icon/4-3.png" />
                <p>自适应</p>
                <span>根据预设的工艺参数，在预应力张拉过程中，动态调整运行参数（如加载速率、持荷时间、卸载速率等）。能充分保证预应力在锚索锚固体系内有效传递，适应协调变形，进而真正做到预应力在锚索上能“加得上、停得稳和锁得住”。</span>
              </div>
              <div class="product2-li"  style="height: 364px;">
                <img src="@/assets/imgs/product/icon/4-4.png" />
                <p>数字化</p>
                <span>预应力张拉施工，采用标准参数预设和全自动运行，实现了预应力张拉施工中设备操作、数据测量、结果记录等工作的全程数字化，数据客观真实可信，可从根本上规范施工管理过程。</span>
              </div>
            </template>

            <template v-if="bannerIndex==5">
              <div class="product2-li"  style="height: 266px;width: 389px">
                <img src="@/assets/imgs/product/icon/5-1.png" />
                <p>多通道高兼容</p>
                <span style="width: 316px">可同时连接并测量多路传感器，普遍兼容适应市面上各类型号的工程监测传感器。</span>
              </div>
              <div class="product2-li"   style="height: 266px;width: 389px">
                <img src="@/assets/imgs/product/icon/5-2.png" />
                <p>低功耗运行使用</p>
                <span style="width: 316px">采用低功耗采集传输技术，最大程度保护传感器，延长传感器使用寿命。</span>
              </div>
              <div class="product2-li"  style="height: 266px;width: 389px">
                <img src="@/assets/imgs/product/icon/5-3.png" />
                <p>柔性配置稳定监测</p>
                <span style="width: 316px">可针对不同需求类型及传感器类型进行工作参数的灵活配置。</span>
              </div>
            </template>
          </div>


        </div>
      </div>


      <div class="product3" :style="{'background-color':bannerIndex!=1?'#FFFFFF':''}">
        <div class="app-content">
          <div class="header-title">产品价值</div>

          <template v-if="bannerIndex==1">
            <div class="product3-ul">
              <div class="product3-li flex">
                <img src="@/assets/imgs/product/icon/1-5.png" />
                <div style="margin-left: 15px">
                  <span class="sp1">施工过程在线化</span>
                  <span  class="sp2">将工程项目设计文件、现场施工、质量验收等重点环节，通过智能硬件进行实时采集，实现过程全链感知。</span>
                </div>
              </div>
              <div class="product3-li flex">
                <img src="@/assets/imgs/product/icon/1-6.png" />
                <div style="margin-left: 15px">
                  <span class="sp1">协同作业网络化</span>
                  <span  class="sp2">以在线化的施工过程数据为基础，集成各个子系统的应用于平台，实现随时随地的网络化协同作业。</span>
                </div>
              </div>
              <div class="product3-li flex">
                <img src="@/assets/imgs/product/icon/1-7.png" />
                <div style="margin-left: 15px">
                  <span class="sp1">监管方式智慧化</span>
                  <span  class="sp2">云平台及终端聚合了先进的智能判断和分析策略，有效帮助相关方聚焦关键问题，主动规避风险，优化执行操作，进而提升质量监管水平。</span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="bannerIndex==2">
            <div class="product3-ul flex-sa">
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/2-5.png" />
                <span class="sp4">原理科学</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/2-6.png" />
                <span class="sp4">测量精确</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/2-7.png" />
                <span class="sp4">操作高效</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/2-8.png" />
                <span class="sp4">安全可靠</span>
              </div>
            </div>
          </template>
          <template v-if="bannerIndex==3">
            <div class="product3-ul flex-sa">
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/3-5.png" />
                <span class="sp4">可靠性好</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/3-6.png" />
                <span class="sp4">实用性强</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/3-7.png" />
                <span class="sp4">灵活度高</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/3-8.png" />
                <span class="sp4">适应性广</span>
              </div>
            </div>
          </template>
          <template v-if="bannerIndex==4">
            <div class="product3-ul flex-sa">
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/4-5.png" />
                <span class="sp4">操作简便</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/4-6.png" />
                <span class="sp4">控制精确</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/4-7.png" />
                <span class="sp4">专业高效</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/4-8.png" />
                <span class="sp4">客观真实</span>
              </div>
            </div>
          </template>
          <template v-if="bannerIndex==5">
            <div class="product3-ul flex-sa">
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/5-4.png" />
                <span class="sp4">低成本使用运维</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/5-2.png" />
                <span class="sp4">低功耗运行</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/5-1.png" />
                <span class="sp4">高兼容性接入</span>
              </div>
              <div class="product3-li">
                <img src="@/assets/imgs/product/icon/5-6.png" />
                <span class="sp4">高效率采集传输</span>
              </div>
            </div>
          </template>

        </div>
      </div>

      <div class="product4">
        <div class="product4-left">
          <img src="@/assets/imgs/solution/5.png"  style="position:absolute;width: 300px;right: 0;bottom: 0;">
        </div>
        <el-carousel height="492px" class="product4-right" :indicator-position="'none'">
          <el-carousel-item v-for="item in projectList" >
            <img style="    width: 100%;height: 100%;object-fit: cover;" @click="toPape(item)" :src="item.cover" />
          </el-carousel-item>
        </el-carousel>
        <div class="app-content">

          <div class="product4-t1">应用场景。</div>
          <div class="product4-t2" v-if="bannerIndex==1">公路、铁路、市政建设等规模大、数量多、分布广、工点散的线性工程，
            建立中心型数据平台进行集群化质量管控。</div>
          <div class="product4-t2" v-if="bannerIndex==2">桥梁、边坡、基坑、隧道等工程锚下预应力的快速准确检测。
          </div>
          <div class="product4-t2" v-if="bannerIndex==3">桥梁、边坡、基坑、隧道等工程的预应力损失试验、摩阻试验、张拉工艺试验与验证等。
            </div>
          <div class="product4-t2" v-if="bannerIndex==4">桥梁、边坡、基坑、隧道等工程的预应力施加、拉拔性试验等。</div>
          <div class="product4-t2" v-if="bannerIndex==5">岩土工程、结构工程中预埋传感器短期及中长期监测。</div>
        </div>
        <div class="product4-more" @click="$router.push({path:'/case'})">查看案例</div>
      </div>
    </div>
    <footers></footers>
    </template>
    <template v-else>
      <wap-index></wap-index>
    </template>
  </div>
</template>
<script type="text/javascript">

  import headers1 from "@/components/header1"
  import footers from "@/components/footers"
  import wapIndex from "../product/wapIndex";
  import axios from "axios";
  import eventBus from "../../assets/js/eventBus";
  export default {
    name: 'index',
    components:{headers1,footers,wapIndex},
    data() {
      return {
        bannerList:[
          ""
        ],
        projectList:[],
        bannerIndex:1,
        selectIndex1:1,
        productIndex:3,
        wapShow:false
      }
    },
    mounted() {
      eventBus.$on("wapShow",(data)=> {
        this.wapShow = data;
        if(!this.wapShow) {
          this.getProjectcList();
          if(this.$route.query.index){
            this.bannerIndex= this.$route.query.index
          }
        }
      })


    },
    methods: {
      toPape(data) {
        this.$router.push({
          path: '/caseDetail',
          query: {
            id: data.id
          }
        })
      },
      //获取案例项目
      getProjectcList() {
        axios.get(this.pageUrl + `/project-case/page?pageNo=${this.selectIndex1}&pageSize=200`).then(res => {
          this.projectList = res.data.data.list;

        })
      },
    },
  }
</script>
<style scoped>
  .product-box{
    margin-top: 80px;
  }
  .product-box .banner-box{

  }
  .product-box .banner-box .banner-left{
    width: 500px;
    height: 500px;
    background: #19203B;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
  .product-box .banner-box .banner-right{
    padding-left: 120px;
  }
  .product-box .banner-box .banner-left ul{
    margin-top: 24px;
    margin-left: 0px;
  }
  .product-box .banner-box .banner-left ul img{
    width: 22px;
    margin-right: 10px;
    margin-top: 9px;
    float: left;
  }
  .product-box .banner-box .banner-left li:first-child{
    border-top: none;
  }
  .product-box .banner-box .banner-left li{
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    cursor: pointer;
    color: #FFFFFF;
    list-style: none;
    border-bottom: 1px solid #FFFFFF;
    padding: 20px 0;
    width: 400px;
    height: 80px;
    position: relative;
    box-sizing: border-box;
  }
  .product-box .banner-box .banner-left li:hover{
    font-size: 24px;
  }
  .product-box .banner-box .banner-left li.select{
    /*padding-left:40px;*/
    color: #308BF1;
  }
  .product-box .banner-box .banner-left li.select:before{
    /*content: " ";*/
    /*width: 26px;*/
    /*height: 8px;*/
    /*background: #308BF1;*/
    /*position: absolute;*/
    /*left: 0px;*/
    /*top: 40px;*/
  }

  .product-box .product1{
    background-color: #F2F4F9;
    width: 100%;
    height: 480px;
    margin: 40px 0 0;
    padding: 40px 0 0;
    box-sizing: border-box;
  }
  .product-box .product1 ul{
    margin: 0;
    padding: 0;
  }
  .product-box .product1 ul li{
    width: 336px;
    height: 120px;
    cursor: pointer;
    margin-bottom: 20px;
    background: #FFFFFF;
    list-style: none;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    justify-content: start;
    position: relative;
    padding-left: 49px;
    box-sizing: border-box;
    align-items: center;
    font-size: 24px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #5C5D5F;
  }
  .product-box .product1 ul li img{
    display:none ;
  }
  /*.product-box .product1 ul li:hover{*/
  /*  background: #0071EF;*/
  /*  color: #FFFFFF;*/
  /*  !*background-image: ;*!*/
  /*}*/
  .product-box .product1 ul li.select{
    background: linear-gradient(135deg, #34E4AA 0%, #2C68FF 100%);
    color: #FFFFFF;
  }
  .product-box .product1 ul li.select img{
    display: block !important;
    position: absolute;
    right: 7px;
    width: 100px;
    bottom: 0;
  }
  .product-box .product1 .product1-right{
    width: 840px;
    height: 400px;
    overflow: hidden;
    position: relative;
  }
  .product-box .product1 .product1-right .bottom{
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
  }
  .product-box .product1 .product1-right .bottom .p2{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
  }
  .product-box .product1 .product1-right .bottom .p2 .p2-1{
    height: 120px;
    width: 800px;
    border-radius: 8px 8px 8px 8px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .product-box .header-title{
    font-size: 32px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    text-align: center;
  }
  .product2{
    padding-top: 40px;
  }
  .product2 .header-gong{
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    padding: 41px 0 10px;
    text-align: left;
    line-height: 2;
  }
  .product2 .product2-ul{
    margin-top: 64px;
  }
  .product2 .product2-ul .product2-li{
    width: 288px;
    height: 340px;
    background: #F1F3F9;
    border-radius: 4px 4px 4px 4px;
    text-align: center;
  }
  .product2 .product2-ul .product2-li:hover{
    background: linear-gradient(135deg, rgba(52, 228, 170, 0.35) 0%, hsla(223, 100%, 59%, 0.35) 100%);
  }
  .product2 .product2-ul .product2-li img{
  width:141px;
  }
  .product2 .product2-ul .product2-li p{
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
  }
  .product2 .product2-ul .product2-li span{
    width: 253px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    display: block;
    text-align: left;
    margin: 4px auto 0;
    line-height: 2;
  }

  .product3{
    padding: 30px 0;
    background: #F2F4F9;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    padding-top: 80px;
    box-sizing: border-box;
  }
  .product3 .product3-li{
    margin-bottom: 40px;
  }
  .product3 .product3-li img{
    width: 141px;
    margin-top: -25px;
  }
  .product3 .product3-li span{
    display: block;
  }
  .product3 .product3-li .sp4{
    font-size: 24px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: bold;
    color: #19191a;
    margin-top: 30px;
    text-align: center;
  }
  .product3 .product3-ul{
    margin-top: 50px;
  }
  .product3 .product3-li .sp1{
    font-size: 18px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    margin-top: 18px;
  }
  .product3 .product3-li .sp2{
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 30px;
  }
  .product4{
    background: #FFFFFF;
    height: 620px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
  }
  .product4 .product4-left{
    width:50%;
    height: 492px;
    background: linear-gradient(134deg, rgba(52,228,170,0.5300) 0%, #2C68FF 100%);
    position: absolute;
    z-index: 1;
    top: 64px;
  }
  .product4 .product4-right{
    width:50%;
    height: 492px;
    position: absolute;
    z-index: 1;
    top: 64px;
    right: 0;
    object-fit: cover;
  }
  .product4 .product4-t1{
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 249px;
    position: relative;
    z-index: 2;
  }
  .product4 .product4-t2{
    color: #FFFFFF;
    width: 545px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
    margin-top: 32px;
    position: relative;
    z-index: 2;
  }
  .product4 .product4-more{
    width: 150px;
    height: 40px;
    background: linear-gradient(137deg, #34E4AA 0%, #34E1AC 0%, #2C68FF 100%);
    border-radius: 0px 300px 0px 0px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: absolute;
    z-index: 2;
    left: 50%;
    bottom: 64px;
  }

  .product2-index6{
    position: absolute;
    top: 104px;
    font-size: 28px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #19203B;
    left: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/view/product/index.vue